var exports = {
  "a": "Box__KzmcEH",
};

module.exports = exports;
